
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.976 6.475a4.58 4.58 0 011.009-1.709c1.667-1.785 4.369-1.785 6.036 0l.456.492h-1.342c-.472 0-.853.408-.853.914s.381.914.853.914h3.411c.473 0 .854-.408.854-.914V2.515c0-.506-.381-.914-.854-.914-.472 0-.853.408-.853.914v1.463l-.467-.503c-2.334-2.5-6.116-2.5-8.45 0a6.442 6.442 0 00-1.408 2.394c-.157.477.077.997.52 1.166.443.168.931-.083 1.088-.557v-.003zM2.213 8.952a.84.84 0 00-.365.234.905.905 0 00-.237.509.893.893 0 00-.011.145v3.646c0 .505.381.914.853.914.473 0 .854-.409.854-.914v-1.46l.47.5c2.333 2.497 6.115 2.497 8.447 0a6.461 6.461 0 001.41-2.392c.158-.477-.077-.997-.52-1.165-.442-.169-.93.083-1.088.557a4.577 4.577 0 01-1.008 1.708c-1.667 1.786-4.369 1.786-6.036 0l-.003-.002-.456-.489h1.345c.472 0 .853-.409.853-.914 0-.506-.381-.914-.853-.914H2.464a.963.963 0 00-.128.008.592.592 0 00-.123.029z","fill":"#282E3E"}})])
          )
        }
      }
    